import SectionHeader from "./SectionHeader";
import SectionCta from "./SectionCta";
import Styles from "./Pills.module.css";

/**
 * TextGrid — `pills` variation. Source: `.industry-list` / `.industry-pill`.
 * A wrapping flex row of text labels.
 *
 * These pills are not filters and not links, so they are `<li>` — not `<button>`
 * as in `slices/CourseGrid` — and carry no hover affordance.
 */
const Pills = ({ primary, items }) => {
	return (
		<section
			className={Styles.wrapper}
			data-theme={primary?.dark_theme ? "dark" : "light"}>
			<div
				className={Styles.container}
				data-contain="true">
				<SectionHeader
					eyebrow={primary?.eyebrow}
					heading={primary?.heading}
					intro={primary?.intro}
				/>
				<ul className={Styles.list}>
					{items?.map((item, index) => (
						<li
							className={Styles.pill}
							key={index}>
							{item?.label}
						</li>
					))}
				</ul>
				<SectionCta
					label={primary?.cta_label}
					link={primary?.cta_link}
				/>
			</div>
		</section>
	);
};

export default Pills;
